import deepCopyObject from './deepCopyObject';
import objectOf from '../objectOf';
import type { TypeDeepCopyConfig } from './types';
import { shouldExcludeDeepCopyValue } from './utils';

// ----------------------------------------------------------------------------

function deepCopyArray<T>(arr: T[], config: TypeDeepCopyConfig = {}): T[] {
    const copy: T[] = [];
    const exclude = config.exclude ? new Set(config.exclude) : undefined;

    for (const value of arr) {
        const type = objectOf(value);

        if (shouldExcludeDeepCopyValue(exclude, { type })) {
            continue;
        }

        if (type === 'Array') {
            copy.push(deepCopyArray(value as T[], config) as T);
        } else if (type === 'Object') {
            copy.push(deepCopyObject(value as Record<string, any>, config) as T);
        } else {
            copy.push(value);
        }
    }

    return copy;
}

// ----------------------------------------------------------------------------

export default deepCopyArray;
